module.exports = "/images/add-group.png?aa7a65a1f8e49cfe373f813c153ac050";